import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import jwtAxios from '@projectK/services/auth/JWT';
import CompanyTheme from '@projectK/constants/CompanyTheme';
import { useAuthUser } from '@projectK/hooks/AuthHooks';
import ProfileData from '../../../../../../libs/modules/src/lib/account/MyProfile/ProfileData';
import {isParent} from '@projectK/context/RolesProvider';

const ProfileFiledData = () => {
  const { user } = useAuthUser();
  const companyTheme = CompanyTheme();
  const [loading, setLoading] = useState(false);
  const [profileFields, setProfileFields] = useState([]);
  const [myProductsId, setMyProductsId] = useState([]);

  useEffect(() => {
    fetchUserProduct();
  }, []);

  useEffect(() => {
    if (myProductsId.length > 0) {
      fetchProfileFields();
    }
  }, [myProductsId]);

  const fetchUserProduct = async () => {
    try {
      const route =
        isParent(user)
          ? `/products/productname/parent/${user.id}`
          : `/products/productname/${user.id}`;
      const response = await jwtAxios.get(route);
      const { data } = response;
      const productIds = data.map((product) => product.product_id);
      setMyProductsId(productIds);
    } catch (error) {
      setMyProductsId([]);
    }
  };

  const fetchProfileFields = async () => {
    try {
      setLoading(true);

      // Fetch user profile fields
      const userProfileResponse = await jwtAxios.get(
        `/profile-fields/userData/user/${user.id}`,
      );
      const userProfileFields = userProfileResponse.data.list;

      // Fetch product profile fields
      const productProfileResponse = await jwtAxios.get(
        `/profile-fields/product-profile/${myProductsId}`,
      );
      const productProfileFields = productProfileResponse.data.list;
      const combinedProfileFields = productProfileFields.map((productField) => {
        const userField = userProfileFields.find(
          (field) =>
            field.product_id === productField.product_id &&
            field.profile_fields_link_id ===
              productField.profile_fields_link_id,
        );
        return userField ? userField : productField;
      });
      setProfileFields(combinedProfileFields);
      setLoading(false);
    } catch (error) {
      setProfileFields([]);
      setLoading(false);
    }
  };

  return (
    <Box my={4}>
      {loading ? (
        <p>Loading...</p>
      ) : profileFields.length > 0 ? (//NOSONAR
        <ProfileData
          profileFields={profileFields}
          companyTheme={companyTheme}
        />
      ) : (
        <p>No profile fields available</p>
      )}
    </Box>
  );
};

export default ProfileFiledData;
